import React, { useState } from "react";
import { connect } from "react-redux";
import { getWidgetSpecificIsVisible } from "@utils/index";
import { CommonProps } from "@utils/interface";
import ChevronDownIcon from "@public/images/dashcam/chevrondown.svg";
import {
  StyledFaqContainer,
  StyledFaqHeading,
  StyledFaqItem,
  StyledQuestion,
  StyledAnswer,
  StyledChevronIcon
} from "./styles";

export interface IFaqItem {
  question: string;
  answer: string;
}

export interface IFaq extends CommonProps {
  heading?: string;
  iterable_data?: IFaqItem[];
}

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    is_visible: getWidgetSpecificIsVisible(
      state.configuration?.normalisedConfig,
      ownProps.id
    )
  };
};

const Faq = (props: IFaq) => {
  const { heading, iterable_data, is_visible, styles } = props;
  const [expandedItems, setExpandedItems] = useState<Set<number>>(new Set());

  const toggleExpanded = (index: number) => {
    setExpandedItems((curr) => {
      const next = new Set(curr);
      if (next.has(index)) next.delete(index);
      else next.add(index);
      return next;
    });
  };

  return is_visible ? (
    <StyledFaqContainer style={styles}>
      <StyledFaqHeading>{heading}</StyledFaqHeading>
      {iterable_data?.map((item: IFaqItem, index: number) => (
        <StyledFaqItem key={index}>
          <StyledQuestion onClick={() => toggleExpanded(index)}>
            <span>{item.question}</span>
            <StyledChevronIcon $isExpanded={expandedItems.has(index)}>
              <ChevronDownIcon />
            </StyledChevronIcon>
          </StyledQuestion>
          {expandedItems.has(index) && (
            <StyledAnswer>{item.answer}</StyledAnswer>
          )}
        </StyledFaqItem>
      ))}
    </StyledFaqContainer>
  ) : (
    <></>
  );
};

export default connect(mapStateToProps)(Faq);